/******************************************************************
 * Archivo : client/src/components/Admin/surveys/ViewDinamic/index.js
 * Proyecto: CB30
 * Módulo  : Visor Dinámico
 *
 * Propósito:
 * Primera pantalla del Visor Dinámico.
 * Permite visualizar todas las encuestas disponibles para selección.
 ******************************************************************/

import React, { Component } from "react";
import { graphql, withApollo } from "react-apollo";
import fetchDynamicSurveysByIds from "../../../../queries/dinamico/fetchDynamicSurveysByIds";


// Query
import fetchDynamicSurveys from "../../../../queries/dinamico/fetchDynamicSurveys";
import fetchDynamicSurveyUserCount from "../../../../queries/dinamico/fetchDynamicSurveyUserCount";



class ViewDinamic extends Component {

  constructor(props) {
  super(props);

  this.state = {
  selectedSurveys: [],
  step: 1,
  filtroEncuesta: "",
  dynamicSurveys: [],
  openSurvey: null,
  selectedQuestions: {},
  selectedPersonFields: ["id"],
  dynamicUserCount: 0
};
}

handleSurveySelection = surveyId => {
  this.setState(prevState => {
    const { selectedSurveys } = prevState;

    if (selectedSurveys.includes(surveyId)) {
      return {
        selectedSurveys: selectedSurveys.filter(id => id !== surveyId)
      };
    }

    return {
      selectedSurveys: [...selectedSurveys, surveyId]
    };
  });
};


handleContinue = async () => {
  try {
    const surveyResult = await this.props.client.query({
      query: fetchDynamicSurveysByIds,
      variables: {
        surveyIds: this.state.selectedSurveys
      },
      fetchPolicy: "network-only"
    });

    const userCountResult = await this.props.client.query({
      query: fetchDynamicSurveyUserCount,
      variables: {
        surveyIds: this.state.selectedSurveys
      },
      fetchPolicy: "network-only"
    });

    this.setState({
      dynamicSurveys: surveyResult.data.dynamicSurveys || [],
      dynamicUserCount:
        userCountResult.data.dynamicSurveyUserCount || 0,
      step: 2
    });
  } catch (error) {
    console.error(
      "Error cargando datos del Visor Dinámico:",
      error
    );
  }
};

handleSurveyFilter = e => {
  this.setState({
    filtroEncuesta: e.target.value
  });
};

handleSurveyToggle = surveyId => {
  this.setState(prevState => ({
    openSurvey:
      prevState.openSurvey === surveyId ? null : surveyId
  }));
};


handleQuestionSelection = (surveyId, fieldId) => {
  this.setState(prevState => {
    const currentQuestions =
      prevState.selectedQuestions[surveyId] || [];

    const alreadySelected = currentQuestions.includes(fieldId);

    const updatedQuestions = alreadySelected
      ? currentQuestions.filter(id => id !== fieldId)
      : [...currentQuestions, fieldId];

    return {
      selectedQuestions: {
        ...prevState.selectedQuestions,
        [surveyId]: updatedQuestions
      }
    };
  });
};

handleSelectAllQuestions = (surveyId, fields) => {
  this.setState(prevState => ({
    selectedQuestions: {
      ...prevState.selectedQuestions,
      [surveyId]: fields.map(field => field.id)
    }
  }));
};

handleClearQuestions = surveyId => {
  this.setState(prevState => ({
    selectedQuestions: {
      ...prevState.selectedQuestions,
      [surveyId]: []
    }
  }));
};

calculateSelectedQuestionColumns = () => {
  let totalColumns = 0;

  this.state.dynamicSurveys.forEach(survey => {
    const selectedFieldIds =
      this.state.selectedQuestions[survey.id] || [];

    survey.fieldcollection.forEach(field => {
      if (!selectedFieldIds.includes(field.id)) {
        return;
      }

      const hasReplica = (field.answers || []).some(
        answer =>
          answer &&
          answer.config &&
          answer.config.replica === true
      );

      totalColumns += hasReplica ? 3 : 2;
    });
  });

  return totalColumns;
};

handlePersonFieldSelection = fieldName => {
  this.setState(prevState => {
    const selected = prevState.selectedPersonFields;

    if (selected.includes(fieldName)) {
      return {
        selectedPersonFields: selected.filter(
          field => field !== fieldName
        )
      };
    }

    return {
      selectedPersonFields: [...selected, fieldName]
    };
  });
};

handleSelectAllPersonFields = () => {
  this.setState({
    selectedPersonFields: [
      "id",
      "nombre",
      "apellido",
      "tipo_de_documento",
      "documento_de_identidad",
      "lugar_de_expedicion",
      "fecha_de_nacimiento",
      "lugar_de_nacimiento",
      "pais_de_nacimiento",
      "genero",
      "raza",
      "grupo_etnico",
      "estado_civil",
      "nivel_educativo",
      "ocupacion",
      "direccion",
      "estrato",
      "localidad",
      "departamento",
      "ciudad",
      "pais_de_residencia",
      "telefono",
      "celular"
    ]
  });
};

handleClearPersonFields = () => {
  this.setState({
    selectedPersonFields: ["id"]
  });
};

handleGenerateCsv = async () => {
  const payload = {
    surveyIds: this.state.selectedSurveys,
    selectedQuestions: this.state.selectedQuestions,
    selectedPersonFields: this.state.selectedPersonFields
  };

 
  try {
    const response = await fetch("/dynamic-csv/generate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    const blob = await response.blob();

const url = window.URL.createObjectURL(blob);

const a = document.createElement("a");
a.href = url;

const contentDisposition = response.headers.get("Content-Disposition");

let nombreArchivo = "dinamico.csv";

if (contentDisposition) {
  const match = contentDisposition.match(/filename="([^"]+)"/);

  if (match && match[1]) {
    nombreArchivo = match[1];
  }
}

a.download = nombreArchivo;

document.body.appendChild(a);
a.click();
a.remove();

window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error("VISOR DINÁMICO - ERROR:", error);
      }
    };



  render() {
    const { data } = this.props;

    if (data.loading) {
      return (
        <div className="container">
          <h1>Visor Dinámico</h1>
          <p>Cargando encuestas...</p>
        </div>
      );
    }

    if (data.error) {
      return (
        <div className="container">
          <h1>Visor Dinámico</h1>
          <div className="alert alert-danger" role="alert">
            {data.error.message}
          </div>
        </div>
      );
    }

const surveys = data.surveys || [];

const filtro = this.state.filtroEncuesta.trim().toLowerCase();

const filteredSurveys = surveys.filter(survey => {
  return (
    (survey.titulo || "").toLowerCase().includes(filtro) ||
    (survey.descripcion || "").toLowerCase().includes(filtro)
  );
});


if (this.state.step === 2) {
 
  const selectedSurveyObjects = this.state.dynamicSurveys || [];

  return (
    <div className="container">
      <h1>Encuestas seleccionadas</h1>

      <hr />

      <p>
        Has seleccionado {selectedSurveyObjects.length} encuesta
        {selectedSurveyObjects.length !== 1 ? "s" : ""}.
      </p>

<div className="card mb-4">
  <div className="card-body">

    <div className="d-flex justify-content-between align-items-center mb-3">

      <div>
        <h5 className="card-title mb-0">
          Datos del informante
        </h5>

      <small className="text-muted">
        {this.state.selectedPersonFields.length} / 23 campos seleccionados
      </small>

      <div className="mb-3">
  <button
    type="button"
    className="btn btn-sm btn-outline-primary mr-2"
    onClick={this.handleSelectAllPersonFields}
  >
    Seleccionar todos
  </button>

  <button
    type="button"
    className="btn btn-sm btn-outline-secondary"
    onClick={this.handleClearPersonFields}
  >
    Limpiar
  </button>
</div>
      
      </div>

    </div>

<div className="row">

  <div className="col-md-6">

    <div className="form-check mb-2">
      <input
        type="checkbox"
        className="form-check-input"
        checked={true}
        disabled
      />
      <label className="form-check-label">
        ID informante
      </label>
    </div>

    <div className="form-check mb-2">
      <input
        type="checkbox"
        className="form-check-input"
        id="person-nombre"
        checked={this.state.selectedPersonFields.includes("nombre")}
        onChange={() =>
        this.handlePersonFieldSelection("nombre")
      }
    />
    
      <label
        className="form-check-label"
        htmlFor="person-nombre"
      >
        Nombre
      </label>
    </div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-documento"
    checked={this.state.selectedPersonFields.includes(
      "documento_de_identidad"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("documento_de_identidad")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-documento"
  >
    Documento de identidad
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-lugar-expedicion"
    checked={this.state.selectedPersonFields.includes(
      "lugar_de_expedicion"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("lugar_de_expedicion")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-lugar-expedicion"
  >
    Lugar de expedición
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-fecha-nacimiento"
    checked={this.state.selectedPersonFields.includes(
      "fecha_de_nacimiento"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("fecha_de_nacimiento")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-fecha-nacimiento"
  >
    Fecha de nacimiento
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-lugar-nacimiento"
    checked={this.state.selectedPersonFields.includes(
      "lugar_de_nacimiento"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("lugar_de_nacimiento")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-lugar-nacimiento"
  >
    Lugar de nacimiento
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-pais-nacimiento"
    checked={this.state.selectedPersonFields.includes(
      "pais_de_nacimiento"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("pais_de_nacimiento")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-pais-nacimiento"
  >
    País de nacimiento
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-genero"
    checked={this.state.selectedPersonFields.includes("genero")}
    onChange={() =>
      this.handlePersonFieldSelection("genero")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-genero"
  >
    Género
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-raza"
    checked={this.state.selectedPersonFields.includes("raza")}
    onChange={() =>
      this.handlePersonFieldSelection("raza")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-raza"
  >
    Raza
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-grupo-etnico"
    checked={this.state.selectedPersonFields.includes(
      "grupo_etnico"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("grupo_etnico")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-grupo-etnico"
  >
    Grupo étnico
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-ciudad"
    checked={this.state.selectedPersonFields.includes("ciudad")}
    onChange={() =>
      this.handlePersonFieldSelection("ciudad")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-ciudad"
  >
    Ciudad
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-telefono"
    checked={this.state.selectedPersonFields.includes("telefono")}
    onChange={() =>
      this.handlePersonFieldSelection("telefono")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-telefono"
  >
    Teléfono
  </label>
</div>

  </div>

  <div className="col-md-6">

    <div className="form-check mb-2 invisible">
      <input type="checkbox" />
      <label>Espacio</label>
    </div>

    <div className="form-check mb-2">
    <input
        type="checkbox"
        className="form-check-input"
        id="person-apellido"
        checked={this.state.selectedPersonFields.includes("apellido")}
        onChange={() =>
        this.handlePersonFieldSelection("apellido")
      }
    />
    
      <label
        className="form-check-label"
        htmlFor="person-apellido"
      >
        Apellido
      </label>
    </div>

    <div className="form-check mb-2">
      <input
        type="checkbox"
        className="form-check-input"
        id="person-tipo-documento"
        checked={this.state.selectedPersonFields.includes(
        "tipo_de_documento"
        )}
        onChange={() =>
        this.handlePersonFieldSelection("tipo_de_documento")
        }
      />

      <label
        className="form-check-label"
        htmlFor="person-tipo-documento"
      >
        Tipo de documento
      </label>
    </div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-estado-civil"
    checked={this.state.selectedPersonFields.includes(
      "estado_civil"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("estado_civil")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-estado-civil"
  >
    Estado civil
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-nivel-educativo"
    checked={this.state.selectedPersonFields.includes(
      "nivel_educativo"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("nivel_educativo")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-nivel-educativo"
  >
    Nivel educativo
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-ocupacion"
    checked={this.state.selectedPersonFields.includes(
      "ocupacion"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("ocupacion")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-ocupacion"
  >
    Ocupación
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-direccion"
    checked={this.state.selectedPersonFields.includes(
      "direccion"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("direccion")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-direccion"
  >
    Dirección
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-estrato"
    checked={this.state.selectedPersonFields.includes("estrato")}
    onChange={() =>
      this.handlePersonFieldSelection("estrato")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-estrato"
  >
    Estrato
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-localidad"
    checked={this.state.selectedPersonFields.includes(
      "localidad"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("localidad")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-localidad"
  >
    Localidad
  </label>
</div>

<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-departamento"
    checked={this.state.selectedPersonFields.includes(
      "departamento"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("departamento")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-departamento"
  >
    Departamento
  </label>
</div>



<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-pais-residencia"
    checked={this.state.selectedPersonFields.includes(
      "pais_de_residencia"
    )}
    onChange={() =>
      this.handlePersonFieldSelection("pais_de_residencia")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-pais-residencia"
  >
    País de residencia
  </label>
</div>



<div className="form-check mb-2">
  <input
    type="checkbox"
    className="form-check-input"
    id="person-celular"
    checked={this.state.selectedPersonFields.includes("celular")}
    onChange={() =>
      this.handlePersonFieldSelection("celular")
    }
  />
  <label
    className="form-check-label"
    htmlFor="person-celular"
  >
    Celular
  </label>
</div>

  </div>

</div>

  </div>
</div>

<div className="alert alert-info">
  <div className="row align-items-center">

    <div className="col-md-9">

      <div>
        Columnas de preguntas seleccionadas:{" "}
        {this.calculateSelectedQuestionColumns()}
      </div>

      <div>
        Campos del informante seleccionados:{" "}
        {this.state.selectedPersonFields.length}
      </div>

      <div>
        Total de columnas a generar:{" "}
        {this.calculateSelectedQuestionColumns() +
          this.state.selectedPersonFields.length}
      </div>

      <div>
        Informantes que participan:{" "}
        {this.state.dynamicUserCount}
      </div>

    </div>

    <div className="col-md-3 text-right">

      <button
        type="button"
        className="btn btn-primary"
        onClick={this.handleGenerateCsv}
      >
        Generar CSV
      </button>

    </div>

  </div>
</div>

      {selectedSurveyObjects.map(survey => (
  <div className="card mb-3" key={survey.id}>
    <div className="card-body">

      <div className="d-flex justify-content-between align-items-center">

  <h5 className="card-title mb-0 mr-3">
    {survey.titulo}
  </h5>

  <div className="text-right">

    <div className="text-muted small mb-1">
      {(this.state.selectedQuestions[survey.id] || []).length} /{" "}
      {survey.fieldcollection.length} preguntas
    </div>

    <button
      type="button"
      className="btn btn-sm btn-primary"
      onClick={() => this.handleSurveyToggle(survey.id)}
    >
      {this.state.openSurvey === survey.id ? "Ocultar" : "Ver"}
    </button>

  </div>

</div>

{this.state.openSurvey === survey.id && (
  <div className="mt-3">
    <p className="mb-1">
      <strong>Preguntas disponibles:</strong>{" "}
      {survey.fieldcollection.length}
    </p>

    {survey.fieldcollection.map(field => (
      <div
        key={field.id}
        className="border rounded p-2 mb-2"
      >

        <input
          type="checkbox"
          className="mr-2"
          checked={
          (this.state.selectedQuestions[survey.id] || []).includes(field.id)
          }
        onChange={() =>
          this.handleQuestionSelection(survey.id, field.id)
          }
        />

        <strong>{field.question}</strong>

        <div className="text-muted">
          Tipo: {field.type}
          {(field.answers || []).some(
            answer =>
            answer &&
            answer.config &&
            answer.config.replica === true
          ) && " · Con réplica"}
        </div>
      </div>
    ))}
  </div>
)}

    </div>

{this.state.openSurvey === survey.id && (
  <div className="mb-3 mt-3">
    <button
      type="button"
      className="btn btn-sm btn-outline-primary mr-2"
      onClick={() =>
        this.handleSelectAllQuestions(
          survey.id,
          survey.fieldcollection
        )
      }
    >
      Seleccionar todas
    </button>

    <button
      type="button"
      className="btn btn-sm btn-outline-secondary"
      onClick={() => this.handleClearQuestions(survey.id)}
    >
      Limpiar
    </button>
  </div>
)}

  </div>
))}
    </div>
  );
}



    return (
  
      <div className="container">
      <h1>Visor Dinámico</h1>

      <hr />

      <div className="form-group">
        <label htmlFor="filtroEncuesta">
          <strong>Buscar encuesta</strong>
        </label>

        <input
          type="text"
          id="filtroEncuesta"
          className="form-control"
          placeholder="Escriba el título o descripción..."
          value={this.state.filtroEncuesta}
          onChange={this.handleSurveyFilter}
        />
      </div>
      
        <hr />

        {filteredSurveys.map(survey => (
          <div className="card mb-3" key={survey.id}>
            <div className="card-body">
              <h5 className="card-title">{survey.titulo}</h5>

              <p className="card-text">
                {survey.descripcion}
              </p>

              <div className="form-check">
               <input
                  type="checkbox"
                  className="form-check-input"
                  id={`survey-${survey.id}`}
                  checked={this.state.selectedSurveys.includes(survey.id)}
                  onChange={() => this.handleSurveySelection(survey.id)}
                />

                <label
                  className="form-check-label"
                  htmlFor={`survey-${survey.id}`}
                >
                  Seleccionar encuesta
                </label>
              </div>
              
            </div>
          </div>
        ))}

        <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
          <strong>
            Encuestas seleccionadas: {this.state.selectedSurveys.length}
          </strong>

          <button
            type="button"
            className="btn btn-primary"
            disabled={this.state.selectedSurveys.length === 0}
            onClick={this.handleContinue}
          >
            Continuar
          </button>
        </div>



      </div>

    );

    
  }
}

export default withApollo(
  graphql(fetchDynamicSurveys)(ViewDinamic)
);


// WEBPACK FOOTER //
// ./src/components/Admin/surveys/ViewDinamic/index.js